import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import { formatDateTime } from '@/features/dashboard/bookingChanges/utils/formatters.ts';
import { EMPTY_VALUE } from '@/components/ui/EmptyValue.tsx';
import DraftCardActions from './DraftCardActions';
import DraftCardHeader from './DraftCardHeader';
import {
  InfoCard,
  InfoCardBody,
  InfoCardRow,
} from '@/components/ui/InfoCard.tsx';

interface DraftCardProps extends React.HTMLAttributes<HTMLDivElement> {
  draft: ChangeDraftVm;
  /**
   * Opis liczby pozycji z perspektywy oglądanego ekranu, np. „5 · w tym
   * 3 tutaj”. Buduje go rodzic — karta nie wie, czyj ekran obsługuje.
   */
  itemsLabel: string;
  onApplyPackage: () => void;
  onSaveAndExit: () => void;
  onDiscardDraft: () => void;
}

const valueClass = 'font-semibold text-ink';

/**
 * Karta szkicu paczki — panel boczny w trybie edycji. Mówi, co szkic zawiera,
 * kto go założył i kiedy zapisał, a pod spodem daje trzy wyjścia z edycji.
 */
const DraftCard = ({
  draft,
  itemsLabel,
  onApplyPackage,
  onSaveAndExit,
  onDiscardDraft,
  ...props
}: DraftCardProps) => (
  <InfoCard tone="accent" {...props}>
    <DraftCardHeader />

    <InfoCardBody className="pb-[18px] pt-4">
      <InfoCardRow label="Pozycje">
        <span className={valueClass}>{itemsLabel}</span>
      </InfoCardRow>
      <InfoCardRow label="Utworzył">
        <span className={valueClass}>{draft.author ?? EMPTY_VALUE}</span>
      </InfoCardRow>
      <InfoCardRow label="Ostatni zapis">
        <span className={valueClass}>
          {draft.lastSavedAt ? formatDateTime(draft.lastSavedAt) : EMPTY_VALUE}
        </span>
      </InfoCardRow>
    </InfoCardBody>

    <DraftCardActions
      onApplyPackage={onApplyPackage}
      onSaveAndExit={onSaveAndExit}
      onDiscardDraft={onDiscardDraft}
    />
  </InfoCard>
);

export default DraftCard;
